module.exports = __webpack_public_path__ + "static/media/hangman08.a011147c.svg";